import { FC } from 'react';
import { Badge, styled } from '@mui/material';
import { useGetSelectedTab } from '../services/flowManager';
import { PendingTabIcon } from '../icons';
import {
  useGetPendingAmount,
  useHandlePendingAmountInterval,
} from '../services/customersTabManager';
export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    border: `2px solid`,
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    borderRadius: '50%',
    marginRight: theme.spacing(1),
  },
}));
export const PendingBadge: FC = () => {
  useHandlePendingAmountInterval();
  const selectedTab = useGetSelectedTab();
  const pendingAmount = useGetPendingAmount();
  return (
    <>
      {pendingAmount ? (
        <StyledBadge
          badgeContent={pendingAmount}
          color="error"
          invisible={!pendingAmount}
          sx={(theme) => ({
            '& .MuiBadge-badge': {
              borderColor:
                selectedTab === 'pending'
                  ? 'white'
                  : theme.palette.background.default,
            },
          })}
        />
      ) : (
        <PendingTabIcon />
      )}
    </>
  );
};
